import React from 'react'
import SvgClose from '#/assets/images/icons/close.svg'
import Button from '#/components/Button'

interface BackFabProps {
  onBack?: (location?: string) => void
}

const BackFab = ({ onBack }: BackFabProps) => (
  <span className='absolute right-8 top-0.5 z-50'>
    <Button
      className='fixed scale-75 rounded-full bg-black p-1 shadow duration-100 hover:scale-100'
      onClick={() => onBack && onBack('fab')}
    >
      <SvgClose className='h-5 w-5 rounded-full text-white' />
    </Button>
  </span>
)

export default React.memo(BackFab)
